import React from 'react';
export const ClinicalEvidence = () => {
  return <section className="mb-12 bg-blue-50 p-6 rounded-lg" data-id="element-77">
      <h2 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-78">
        The Clinical Evidence They Don't Want You to See
      </h2>
      <p className="text-gray-700 mb-6" data-id="element-79">
        Underground research (funded independently to avoid industry influence)
        has produced startling results:
      </p>
      <div className="mb-8" data-id="element-80">
        <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-81">
          Study 1 - Major East Coast University (2024):
        </h3>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4" data-id="element-82">
          <li data-id="element-83">60 women, ages 35-55, tracked for 6 months</li>
          <li data-id="element-84">
            Cotton pillowcase group: 23% increase in measured wrinkle depth
          </li>
          <li data-id="element-85">Silk pillowcase group: 31% decrease in measured wrinkle depth</li>
        </ul>
      </div>
      <div className="mb-8" data-id="element-86">
        <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-87">
          Study 2 - Independent Sleep Research Institute (2021):
        </h3>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4" data-id="element-88">
          <li data-id="element-89">Microscopic analysis of overnight skin changes</li>
          <li data-id="element-90">
            Cotton users: significant collagen damage visible after single night
          </li>
          <li data-id="element-91">Silk users: accelerated skin repair and regeneration</li>
        </ul>
      </div>
      <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2 mb-6" data-id="element-92">
        "The results were so dramatic, three major cosmetic companies tried to
        buy the research to bury it," Dr. Grant reveals.
      </blockquote>
      <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-93">
        <div className="md:w-1/2" data-id="element-94">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iTpfwnMGKmGjCDNJs5xswb/beforeafter.png" alt="Before and after comparison showing visible skin improvement - left side shows skin with wrinkles, right side shows smoother, more youthful skin" className="rounded-lg shadow-lg w-full" data-id="element-95" />
        </div>
        <div className="md:w-1/2" data-id="element-96">
          <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-97">
            The Measurable Results
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-98">
            Dr. Grant began documenting her patients' improvements with clinical
            photography:
          </p>
          <div className="mb-4" data-id="element-99">
            <h4 className="font-bold text-blue-800 mb-2" data-id="element-100">
              60-Night Results (Average across 47 patients):
            </h4>
            <ul className="list-disc pl-6 text-gray-700 space-y-1" data-id="element-101">
              <li data-id="element-102">Up to 34% reduction in visible sleep lines</li>
              <li data-id="element-103">28% improvement in skin hydration levels</li>
              <li data-id="element-104">41% decrease in morning facial puffiness</li>
              <li data-id="element-105">52% improvement in overall skin texture</li>
            </ul>
          </div>
          <div data-id="element-106">
            <h4 className="font-bold text-blue-800 mb-2" data-id="element-107">1-Year Results:</h4>
            <ul className="list-disc pl-6 text-gray-700 space-y-1" data-id="element-108">
              <li data-id="element-109">67% reduction in new wrinkle formation</li>
              <li data-id="element-110">45% improvement in existing wrinkle depth</li>
              <li data-id="element-111">38% decrease in treatment frequency needed</li>
              <li data-id="element-112">89% patient satisfaction rate</li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
};